import { Component, forwardRef, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { AbstractValueAccessor, MakeProvider } from '../../../../comum/controls/AbstractValueAccessor';


@Component({
  selector: 'spinvalue',
  templateUrl: './spinvalue.component.html',
  providers: [ MakeProvider(SpinvalueComponent) ]
})

export class SpinvalueComponent extends AbstractValueAccessor {
  @Input()
  max = 500;
  @Input()
  min = 1;
  @Input() label: string;
  current:number = this.min;

  
  doClickDown() {
    this.current +=  -1;
    if (this.current<0) this.current = this.min;
    this.onChange(this.current);
  }

  doClickUp() {
    this.current +=  1;
    this.onChange(this.current);
  }

}

